import React, {useEffect} from "react";
import UseData from "../../Hooks/UseData";
import Footer from "../../Share/Footer";
import PageTitle from "../../Share/PageTitle";
import LineItem from "./LineItem";
import ResumeCardTwo from "./ResumeCardTwo";
import {useTranslation} from "react-i18next";
import { RiCodeBoxFill } from "react-icons/ri";
import ReactGA from "react-ga4";

const ResumeTwo = () => {
  const { lineArray } = UseData();
  const { t, i18n } = useTranslation();

  return (
    <>
      <PageTitle title={t("Skills")}></PageTitle>

      <section className="bg-white  lg:rounded-2xl dark:bg-[#111111]">
        <div data-aos="fade">
          <div className="container sm:px-5 md:px-10 lg:px-14">
            <div className="py-12 px-4 md:px-0">
              {/*Resume page title */}
              <h2 className="after-effect">{t("Skills")}</h2>
              <div className="grid grid-cols-1 gap-x-6 gap-y-6 mt-[30px]">
                {/* resume items map */}
                <ResumeCardTwo />
              </div>
            </div>
          </div>
          {/* End .container */}

          <div className="container bg-color-810 dark:bg-[#0D0D0D] py-12 px-2 sm:px-5 md:px-10 lg:px-20">
            <div className="grid grid-cols-1 gap-8">
              <div className="col-span-1">
                <h3 className="text-5xl dark:text-white font-medium mb-6">
                  {t("WorkingSkills")}
                </h3>
                {/* Experience percent element */}
                {lineArray.map((item, i) => (
                  <LineItem item={item} key={i} />
                ))}
              </div>
            </div>
          </div>
          {/* End .container */}

          <Footer condition={false} bg={"#FFFF"} />
        </div>
      </section>
    </>
  );
};

export default ResumeTwo;
